"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CancellationPolicy = _interopRequireDefault(require("./CancellationPolicy"));
var _CancellationPolicyMobile = _interopRequireDefault(require("./CancellationPolicyMobile"));
var _default = exports["default"] = {
  CancellationPolicyDesktop: _CancellationPolicy["default"],
  CancellationPolicyMobile: _CancellationPolicyMobile["default"]
};